import { RequestState } from 'astra-core/typings/api'

export const requestInitialState: RequestState = {
  loading: false,
  error: null,
  refreshLoading: false,
  loaded: false
}
